"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postCollect = exports.getBanner = void 0;
const tslib_1 = require("tslib");
const common_utils_1 = require("@as-react/common-utils");
const createUrl_1 = require("../../utils/createUrl");
const urlMapping = {
    banners: {
        client: 'search/v2/banners/{organisationId}',
    },
};
const getBanner = (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ searchApi, organisationId }, { location, placement }) {
    const requestUrl = (0, createUrl_1.createUrl)(searchApi, urlMapping.banners, false, {
        organisationId,
    });
    const axiosConfig = {
        method: 'POST',
        url: requestUrl,
        data: {
            location,
            filters: [
                {
                    field: 'placement',
                    operator: 'EQUAL',
                    value: placement,
                },
            ],
            page: 1,
            per_page: 1,
        },
    };
    const result = yield common_utils_1.axiosClient.request(axiosConfig);
    return result.data;
});
exports.getBanner = getBanner;
const postCollect = (_a, _b) => tslib_1.__awaiter(void 0, [_a, _b], void 0, function* ({ collectApi }, { event, data }) {
    if (collectApi === null) {
        return;
    }
    const axiosConfig = {
        method: 'POST',
        url: collectApi,
        params: { [event]: '' },
        headers: { 'Content-Type': 'application/json' },
        data: {
            data,
        },
        responseType: 'text',
    };
    yield common_utils_1.axiosClient.request(axiosConfig);
});
exports.postCollect = postCollect;
//# sourceMappingURL=zitcha.api.js.map